var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display && _vm.files.length > 0)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.files,"locale":"ja-jp","hide-default-footer":"","item-key":"item_no","dense":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }